export default interface ICompData {
    fieldId?: number | null;
    fieldName: string;
    fieldRulesApplied?: boolean | null;
    include?: string | null;
    sourceInitial: string;
    sourceInitialIdx?: number | undefined;
    value: string;
}

export function newCompData(): ICompData {
    const compData: ICompData = {
        fieldName: '',
        sourceInitial: '',
        value: ''
    };
    return compData;
}
